import { faker } from "@faker-js/faker";
import { useEffect, useState } from "react";
import useAppSelector from "@/core/helpers/useAppSelector";
import { SoundButton } from "@/shared/ui";
import { TextInput } from "@/shared/ui";
import { playerInfoSelector } from "@/domains/player/slice";
import useInventoryManager from "@/domains/inventory/hooks/inventory/useInventoryManager";
import InventoryContent from "@/domains/inventory/components/InventoryContent";
import InventoryWrapper from "@/domains/inventory/components/InventoryWrapper";

export default function InventoryAddItem() {
  const playerInfo = useAppSelector(playerInfoSelector);
  const { addItem } = useInventoryManager();
  const [inventoryOwnerId, setInventoryOwnerId] = useState("");
  const [inventoryOwnerType, setInventoryOwnerType] = useState("character");
  const [itemId, setItemId] = useState(String(faker.number.int({ min: 1, max: 200 })));
  const [quantity, setQuantity] = useState(String(faker.number.int({ min: 1, max: 200 })));

  useEffect(() => {
    if (playerInfo) {
      setInventoryOwnerId(String(playerInfo.character.id));
    }
  }, [playerInfo]);

  const submitHandler = async () => {
    await addItem({
      details: [],
      inventoryOwnerId,
      inventoryOwnerType,
      itemId: Number(itemId),
      quantity: Number(quantity),
    });
    setItemId(String(faker.number.int({ min: 1, max: 200 })));
    setQuantity(String(faker.number.int({ min: 1, max: 200 })));
  };

  if (!playerInfo) return null;

  return (
    <InventoryWrapper>
      <InventoryContent className="py-4">
        <div className="flex flex-col gap-1.5">
          <div className="">
            <div className="text-12 font-medium text-white/60">inventoryOwnerId</div>
            <TextInput value={inventoryOwnerId} onChange={setInventoryOwnerId} />
          </div>
          <div className="">
            <div className="text-12 font-medium text-white/60">inventoryOwnerType</div>
            <TextInput value={inventoryOwnerType} onChange={setInventoryOwnerType} />
          </div>
          <div className="">
            <div className="text-12 font-medium text-white/60">itemId</div>
            <TextInput value={itemId} onChange={setItemId} />
          </div>
          <div className="">
            <div className="text-12 font-medium text-white/60">quantity</div>
            <TextInput value={quantity} onChange={setQuantity} />
          </div>
          <SoundButton onClick={submitHandler}>Add</SoundButton>
        </div>
      </InventoryContent>
    </InventoryWrapper>
  );
}
